export default __webpack_public_path__ + "static/img1-fdd250ca84b9517cf49090995f5c85e5.png";